/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for RegionResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, RegionListDTO } from "../models";

@Injectable({ providedIn: "root" })
export class RegionResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    getAllRegions(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<RegionListDTO>>;
    getAllRegions(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<RegionListDTO>>>;
    getAllRegions(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<RegionListDTO>>>;
    getAllRegions(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-regions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllRegions1(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<RegionListDTO>>;
    getAllRegions1(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<RegionListDTO>>>;
    getAllRegions1(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<RegionListDTO>>>;
    getAllRegions1(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-regions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllRegions2(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<RegionListDTO>>;
    getAllRegions2(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<RegionListDTO>>>;
    getAllRegions2(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<RegionListDTO>>>;
    getAllRegions2(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-regions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllRegions4(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<RegionListDTO>>;
    getAllRegions4(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<RegionListDTO>>>;
    getAllRegions4(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<RegionListDTO>>>;
    getAllRegions4(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-regions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllRegions3(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<RegionListDTO>>;
    getAllRegions3(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<RegionListDTO>>>;
    getAllRegions3(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<RegionListDTO>>>;
    getAllRegions3(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-regions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllRegions6(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<RegionListDTO>>;
    getAllRegions6(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<RegionListDTO>>>;
    getAllRegions6(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<RegionListDTO>>>;
    getAllRegions6(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-regions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAllRegions5(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<RegionListDTO>>;
    getAllRegions5(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<RegionListDTO>>>;
    getAllRegions5(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<RegionListDTO>>>;
    getAllRegions5(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-regions`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
